import React from "react"
import { Equivalence } from "../../model/Equivalence"
import "./equivalenceCard.css"
import errorIcon from "../../../assets/icons/ico_error_info.svg"
import { CalculationState } from "../../model/CalculationResult"
import DataStore, { Screens } from "../../dataStore/DataStore"

interface IEquivalenceCard {
  cardType: EquivalenceCardType
  title: number
  firstEquivalence: Equivalence
  secondEquivalence: Equivalence
  handleClick: () => void
  loadingState: CalculationState
}

export enum EquivalenceCardType {
  co2,
  cost
}

const EquivalenceCard: React.FunctionComponent<IEquivalenceCard> = (props) => {
  const dataStore = DataStore.useStore()

  function shareData(type: string) {
    if (window._paq !== undefined && dataStore.isCookiesAccepted()) {
      window._paq.push(["trackEvent", "result-page", "card", type])
    }
  }

  return (
    <>
      {props.loadingState == CalculationState.loading ? (
        <div>
          {" "}
          <div className="equivalence-card-wrapper">
            <div className="title loading-state"></div>
            <div className="subtext loading-state"></div>
            <div className="equivalence-layout">
              <div className="equivalence-icon-layout">
                <div
                  className={
                    props.cardType == EquivalenceCardType.co2
                      ? "icon loading-state --green"
                      : "icon loading-state --purple"
                  }
                />
              </div>
              <div className="equivalence-text-layout">
                <div className="equivalenceText loading-state"></div>
                <div className="equivalenceSubText loading-state"></div>
              </div>
            </div>

            <div className="equivalence-layout">
              <div className="equivalence-icon-layout">
                <div
                  className={
                    props.cardType == EquivalenceCardType.co2
                      ? "icon loading-state --green"
                      : "icon loading-state --purple"
                  }
                />
              </div>

              <div className="equivalence-text-layout">
                <div className="equivalenceText loading-state"></div>
                <div className="equivalenceSubText loading-state"></div>
              </div>
            </div>
          </div>
          <div
            className="equivalence-button"
            onClick={() => {
              props.handleClick()
            }}
          ></div>{" "}
        </div>
      ) : (dataStore.calculationResult.vvsCost === 0 &&
          props.cardType === EquivalenceCardType.cost &&
          !dataStore.calculationResult.isWalkingDistance) ||
        props.loadingState === CalculationState.error ? (
        <div>
          <div className="equivalence-card-wrapper">
            <img className="error-icon" src={errorIcon} alt=""></img>
            <div className="error-message">
              Wähle eine andere Route im VVS-Tarifgebiet um Deine Ersparnis zu berechnen.
            </div>
          </div>
          <div
            className="equivalence-button"
            onClick={() => {
              dataStore.setCurrentScreen(Screens.landing)
            }}
          >
            Route ändern
          </div>
        </div>
      ) : props.title > 0 ? (
        <div>
          {" "}
          <div className="equivalence-card-wrapper">
            <div className="title">
              {props.cardType === EquivalenceCardType.co2
                ? new Intl.NumberFormat("de-DE").format(Math.round(props.title))
                : new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
                    Math.round(props.title * 1e2) / 1e2
                  )}
              {props.cardType === EquivalenceCardType.co2 ? " kg CO2" : " €"}
            </div>
            <svg
              className="refresh"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              onClick={() => {
                dataStore.refreshEquivalences(props.cardType)
              }}
            >
              <path
                d="M17.462 16.908l-.277.291c-2.863 2.864-7.507 2.864-10.37 0-1.594-1.593-2.3-3.737-2.121-5.818h1.34c-.184 1.739.39 3.543 1.723 4.876 2.344 2.343 6.142 2.343 8.486 0 .09-.09.176-.183.26-.277h-3.089v-1.333h5.38v5.38h-1.332v-3.12zm-9.964-8.86h3.088V9.38h-5.38V4h1.332v3.12a7.6 7.6 0 0 1 .277-.292c2.863-2.863 7.507-2.863 10.37 0 1.594 1.594 2.3 3.737 2.121 5.819h-1.34c.184-1.739-.39-3.543-1.723-4.876-2.344-2.343-6.142-2.343-8.486 0a6.74 6.74 0 0 0-.26.276z"
                fill="#666"
                fillRule="evenodd"
              />
            </svg>
            <div className="subtext">Das entspricht:</div>
            <div className="equivalence-layout">
              <div className="equivalence-icon-layout">
                <img className="icon" src={props.firstEquivalence.icon} alt="" />
                <img className="equal-icon" src={props.firstEquivalence.equalIcon} alt="" />
              </div>
              <div className="equivalence-text-layout">
                <div className="equivalenceText">
                  {new Intl.NumberFormat("de-DE").format(props.firstEquivalence.comparisonValue)}
                </div>
                <div className="equivalenceSubText">{props.firstEquivalence.message}</div>
              </div>
            </div>

            <div className="equivalence-layout">
              <div className="equivalence-icon-layout">
                <img className="icon" src={props.secondEquivalence.icon} alt="" />
                <img className="equal-icon" src={props.secondEquivalence.equalIcon} alt="" />
              </div>

              <div className="equivalence-text-layout">
                <div className="equivalenceText">
                  {new Intl.NumberFormat("de-DE").format(props.secondEquivalence.comparisonValue)}
                </div>
                <div className="equivalenceSubText">{props.secondEquivalence.message}</div>
              </div>
            </div>
          </div>
          <div
            className="equivalence-button"
            onClick={() => {
              shareData("share")
              props.handleClick()
            }}
          >
            {props.cardType === EquivalenceCardType.co2 ? "CO2-Ersparnis teilen" : "mehr erfahren"}
          </div>{" "}
        </div>
      ) : (
        <div>
          {" "}
          <div className="equivalence-card-wrapper">
            <img className="error-icon" src={errorIcon} alt=""></img>
            <div className="error-message">
              Mit dieser Ticket-Option sparst Du auf dieser Route nur CO2 Emission. Du kannst trotzdem unsere
              zahlreichen Vorteile nutzen
            </div>
          </div>
          <div
            className="equivalence-button"
            onClick={() => {
              props.handleClick()

              shareData("learn-more")
            }}
          >
            Mehr Erfahren
          </div>
        </div>
      )}
    </>
  )
}

export default EquivalenceCard
